const Flag = ({ country }) => {
  return (
    <picture>
      <img src={`https://flagcdn.com/28x21/${country}.webp`} width='28' height='21' alt={country} />
    </picture>
  );
};

export default Flag;
